var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.9,148.59c-14.17-27,18.58-47,42.07-39.22,34.92,11.58,38,54.51,25.83,83.74-15.26,36.64-45.68,68.33-69.65,99.39L78.48,404.81C67.56,419,82.24,443.32,99.54,441.52l215.09-22.4c13.1-1.36,24.4-10.23,24.4-24.4,0-12.13-11.21-25.77-24.4-24.39L99.54,392.72l21.07,36.71q59.1-76.56,118.19-153.14C270.61,234.94,301,187,287,132.46,274.43,83.39,225.47,48.29,174.61,61c-48.8,12.21-73,68.14-49.84,112.21,14.61,27.81,56.74,3.17,42.13-24.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M425.28,385.15a33.34,33.34,0,0,0,21.21-8.78,22.47,22.47,0,0,0,6.2-9.66,22.63,22.63,0,0,0,2.59-11.56l-1.07-8a30,30,0,0,0-7.72-13.24l-6.07-4.69a30,30,0,0,0-15.14-4.1,33.47,33.47,0,0,0-21.22,8.79,22.56,22.56,0,0,0-6.2,9.66,22.49,22.49,0,0,0-2.58,11.55l1.07,8a30,30,0,0,0,7.71,13.24l6.08,4.69a29.81,29.81,0,0,0,15.14,4.09Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.498a25a351de0a0f381c79e5b114e65f.svg";
export { ForwardRef as ReactComponent };